(function () {
  var drawer = document.querySelector('[data-mobile-drawer]');
  var trigger = document.querySelector('[data-mobile-menu-trigger]');
  var closeButton = document.querySelector('[data-mobile-menu-close]');
  var overlay = document.querySelector('[data-mobile-menu-overlay]');
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartTrigger = document.querySelector('[data-cart-drawer-trigger]');
  var cartClose = document.querySelector('[data-cart-drawer-close]');
  var cartOverlay = document.querySelector('[data-cart-drawer-overlay]');
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchInput = document.querySelector('[data-predictive-search-input]');
  var searchResults = document.querySelector('[data-predictive-search-results]');
  var lastFocus = null;
  var searchTimer = null;

  function focusable(container) {
    return Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
  }

  function openDrawer() {
    if (!drawer || !trigger) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('asc-drawer-open');
    window.setTimeout(function () {
      var items = focusable(drawer);
      if (items.length) items[0].focus();
    }, 20);
  }

  function closeDrawer() {
    if (!drawer || !trigger) return;
    drawer.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('asc-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  if (trigger && drawer) {
    trigger.addEventListener('click', openDrawer);
    if (closeButton) closeButton.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = focusable(drawer);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function openCartDrawer() {
    if (!cartDrawer || !cartTrigger) return;
    lastFocus = document.activeElement;
    cartDrawer.hidden = false;
    cartTrigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('asc-drawer-open');
    window.setTimeout(function () {
      var items = focusable(cartDrawer);
      if (items.length) items[0].focus();
    }, 20);
  }

  function closeCartDrawer() {
    if (!cartDrawer || !cartTrigger) return;
    cartDrawer.hidden = true;
    cartTrigger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('asc-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  if (cartTrigger && cartDrawer) {
    cartTrigger.addEventListener('click', openCartDrawer);
    if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
    cartDrawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeCartDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = focusable(cartDrawer);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function closeSearchPanel() {
    if (!searchPanel || !searchToggle) return;
    searchPanel.hidden = true;
    searchToggle.setAttribute('aria-expanded', 'false');
    if (searchResults) searchResults.hidden = true;
    if (searchInput) searchInput.setAttribute('aria-expanded', 'false');
  }

  function openSearchPanel() {
    if (!searchPanel || !searchToggle) return;
    searchPanel.hidden = false;
    searchToggle.setAttribute('aria-expanded', 'true');
    window.setTimeout(function () {
      if (searchInput) searchInput.focus();
    }, 20);
  }

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      if (searchPanel.hidden) {
        openSearchPanel();
      } else {
        closeSearchPanel();
      }
    });

    searchPanel.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeSearchPanel();
        searchToggle.focus();
      }
    });
  }

  function moneyFromSuggestion(item) {
    if (!item.price) return '';
    return item.price;
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function renderPredictiveResults(resources, query) {
    if (!searchResults || !searchInput) return;
    var products = resources && resources.results && resources.results.products ? resources.results.products : [];
    var collections = resources && resources.results && resources.results.collections ? resources.results.collections : [];
    var pages = resources && resources.results && resources.results.pages ? resources.results.pages : [];
    var articles = resources && resources.results && resources.results.articles ? resources.results.articles : [];
    var html = '';

    products.slice(0, 6).forEach(function (item) {
      var image = item.featured_image && item.featured_image.url ? '<img src="' + item.featured_image.url + '&width=90" alt="">' : '<span class="asc-predictive-search__thumb" aria-hidden="true"></span>';
      html += '<a href="' + item.url + '">' + image + '<strong>' + escapeHTML(item.title) + '</strong><span>' + escapeHTML(moneyFromSuggestion(item)) + '</span></a>';
    });

    collections.slice(0, 3).forEach(function (item) {
      html += '<a href="' + item.url + '"><span class="asc-predictive-search__thumb" aria-hidden="true"></span><strong>' + escapeHTML(item.title) + '</strong><span>Collection</span></a>';
    });

    pages.concat(articles).slice(0, 3).forEach(function (item) {
      html += '<a href="' + item.url + '"><span class="asc-predictive-search__thumb" aria-hidden="true"></span><strong>' + escapeHTML(item.title) + '</strong><span>Guide</span></a>';
    });

    if (!html && query) {
      html = '<a href="/search?q=' + encodeURIComponent(query) + '"><span class="asc-predictive-search__thumb" aria-hidden="true"></span><strong>No quick matches</strong><span>Search the store</span></a>';
    }

    searchResults.innerHTML = html;
    searchResults.hidden = !html;
    searchInput.setAttribute('aria-expanded', html ? 'true' : 'false');
  }

  function fetchPredictiveSearch(query) {
    if (!query || query.length < 2) {
      renderPredictiveResults(null, '');
      return;
    }

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (json) { renderPredictiveResults(json && json.resources, query); })
      .catch(function () { renderPredictiveResults(null, query); });
  }

  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      window.clearTimeout(searchTimer);
      var query = searchInput.value.trim();
      searchTimer = window.setTimeout(function () {
        fetchPredictiveSearch(query);
      }, 180);
    });

    searchInput.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        searchResults.hidden = true;
        searchInput.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('click', function (event) {
      if (!searchResults.hidden && !event.target.closest('.asc-header__search')) {
        searchResults.hidden = true;
        searchInput.setAttribute('aria-expanded', 'false');
      }

      if (searchPanel && !searchPanel.hidden && !event.target.closest('[data-search-panel]') && !event.target.closest('[data-search-toggle]')) {
        closeSearchPanel();
      }
    });
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('[data-filter-summary]');
    if (!summary) return;
    var details = summary.closest('details');
    if (!details) return;
    window.setTimeout(function () {
      if (details.open) {
        document.querySelectorAll('.asc-filter details[open]').forEach(function (item) {
          if (item !== details) item.removeAttribute('open');
        });
      }
    });
  });
})();

(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  var revealSelector = [
    '.asc-hero__content > *',
    '.asc-hero__media',
    '.asc-trust__intro',
    '.asc-trust__item',
    '.asc-sports .asc-section-heading',
    '.asc-sports__card',
    '.asc-featured__head',
    '.asc-featured__grid > *',
    '.asc-promos__panel',
    '.asc-values__intro',
    '.asc-values__item',
    '.asc-reviews .asc-section-heading',
    '.asc-reviews__empty',
    '.asc-newsletter__inner',
    '.asc-collection__hero > *',
    '.asc-collection__nav',
    '.asc-collection__tools',
    '.asc-collection__grid > *',
    '.asc-product__media',
    '.asc-product__panel > *',
    '.asc-product-data > *',
    '.asc-product-description > *',
    '.asc-product-accordions > *',
    '.asc-product-related > *',
    '.asc-product-reassurance > *',
    '.asc-cart > *',
    '.asc-page .asc-section-heading',
    '.asc-page__content',
    '.shopify-policy__title',
    '.shopify-policy__body',
    '.asc-search > *',
    '.av-blog > *',
    '.av-blog__card',
    '.av-article > *',
    '.asc-404 > *',
    '.asc-footer__inner > *'
  ].join(',');

  function isInViewport(element) {
    var rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.94 && rect.bottom > 0;
  }

  function reveal(element) {
    element.classList.add('is-revealed');
    if (observer) observer.unobserve(element);
  }

  function prepare(container) {
    var root = container && container.querySelectorAll ? container : document;
    var targets = Array.prototype.slice.call(root.querySelectorAll(revealSelector));
    var parentCounts = new Map();

    targets.forEach(function (element) {
      if (element.dataset.ascMotionBound) return;
      if (element.closest('[hidden], .asc-mobile-shell, .asc-cart-drawer, .asc-header, .asc-sticky-atc')) return;

      element.dataset.ascMotionBound = 'true';
      element.classList.add('asc-reveal');

      var parent = element.parentElement;
      var count = parentCounts.get(parent) || 0;
      parentCounts.set(parent, count + 1);
      element.style.setProperty('--asc-reveal-delay', Math.min(count * 55, 220) + 'ms');

      if (reduceMotion.matches || !observer || isInViewport(element)) {
        reveal(element);
      } else {
        observer.observe(element);
      }
    });

    document.documentElement.classList.add('asc-motion-ready');
  }

  if ('IntersectionObserver' in window && !reduceMotion.matches) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) reveal(entry.target);
      });
    }, {
      rootMargin: '0px 0px -7% 0px',
      threshold: 0.04
    });
  }

  function init() {
    prepare(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    prepare(event.target);
  });
})();
